import React, {useContext, useEffect, useState} from "react";
import {
    Button,
    ButtonGroup,
    Card,
    DataTable,
    Layout,
    Page,
    SkeletonBodyText
} from "@shopify/polaris";
import axios from "../../axios";
import {ShopContext} from "../../App";
import {useHistory} from "react-router-dom";

function Templates() {
    const config = useContext(ShopContext);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [templates, setTemplates] = useState([]);
    const [pageDetails, setPageDetails] = useState({
        totalPages: 0,
        previousPage: false,
        nextPage: false,
        totalItems: 0
    });
    const router = useHistory();
    /**
     * get the skeleton content for page data table
     * @returns {[]}
     */
    const getTableSkeletonContent = () => {
        let skeleton = [];
        for (let i = 0; i < 4; i++) {
            skeleton.push([
                <SkeletonBodyText lines={1}/>,
                <SkeletonBodyText lines={1}/>,
            ]);
        }
        return skeleton;
    }
    let skeleton = getTableSkeletonContent();
    /**
     * Column content types of data table
     * @returns {string[]}
     */
    const columnContentTypes = () => {
        return [
            'text',
            'text'
        ];
    }
    /**
     * Data table headings
     * @returns {string[]}
     */
    const tableHeadings = () => {
        return [
            'Message Template',
            'Action'
        ];
    }
    /**
     * process the response to generate the table columns data
     * @param templates
     * @returns {[]}
     */
    const _processResponseTemplates = (templates) => {
        let processedTemplates = [];
        if (templates.length > 0) {
            templates.forEach((template) => {
                let newTemplate = [];
                newTemplate.push(<>{template.message_text}</>);
                newTemplate.push(<ButtonGroup segmented={true}>
                    <Button primary onClick={() => {
                        router.push(`/templates/${template.id}/edit`);
                    }}>Edit</Button>
                    <Button onClick={() => {
                        deleteTemplate(template.id)
                    }}>Delete</Button>
                </ButtonGroup>);
                processedTemplates.push(newTemplate);
            });
        }
        return processedTemplates;
    }
    /**
     * process the response API
     * @param response
     * @private
     */
    const _processApiResponse = (response) => {
        if (!response.error) {
            let templates = _processResponseTemplates(response.data.data);
            setTemplates(templates);
            setPageDetails({
                totalPages: response.data.totalPages,
                previousPage: response.data.previousPage,
                nextPage: response.data.nextPage,
                totalItems: response.data.totalItems
            })
        }
    }
    /**
     * load template from API's
     */
    const loadTemplates = () => {
        setLoading(true);
        axios.get(`/templates?page=${page}`, {
            "headers": {
                shopOrigin: config.shopOrigin,
                xShopHost: config.host,
            }
        }).then((response) => {
            setLoading(false);
            _processApiResponse(response);
        }).catch((error) => {
            setLoading(false);
        });
    }
    /**
     * Delete the template by ID
     * @param templateId
     */
    const deleteTemplate = (templateId) => {
        setLoading(true);
        axios.delete(`/templates/${templateId}?page=${page}`, {
            "headers": {
                shopOrigin: config.shopOrigin,
                xShopHost: config.host,
            }
        }).then((response) => {
            setLoading(false);
            _processApiResponse(response);
        }).catch((error) => {
            setLoading(false);
        });
    };


    /**
     * Load checkouts when page loads
     * or load when the particular state changed
     */
    useEffect(() => {
        loadTemplates();
        // eslint-disable-next-line
    }, [page]);

    return (
        <Page fullWidth
              title="Templates"
              primaryAction={{
                  content: 'Create new template', onAction: () => {
                      router.push('/templates/0/create');
                  }
              }}
              pagination={{
                  hasPrevious: pageDetails.previousPage,
                  hasNext: pageDetails.nextPage,
                  onNext: () => {
                      setPage(page + 1);
                  },
                  onPrevious: () => {
                      setPage(page - 1);
                  }
              }}
        >
            <Layout>
                <Layout.Section>
                    <Card>
                        <DataTable
                            columnContentTypes={columnContentTypes()}
                            headings={tableHeadings()}
                            rows={(loading) ? skeleton : templates}
                            footerContent={(loading) ? `Loading templates! please wait...` : `Showing ${templates.length} of ${pageDetails.totalItems} results`}
                        />
                    </Card>
                </Layout.Section>
            </Layout>
        </Page>
    );
}

export default Templates;
